<h2>{{ user?.first_name }} {{ user?.last_name }}</h2>

<div class="grid-x grid-padding-x">
  <div class="medium-4 cell page__divider">
    <rav-form
      [formGroup]="formGroup"
      (formSubmit)="updateProfile(formGroup.value)"
      [fields]="[{ name: 'first_name' }, { name: 'last_name' }, { name: 'phone_number' }, { name: 'email' }]"
      buttonText="Save"
      hasCancel="true"
      (cancel)="getProfile()"
      [successMessage]="updateProfileSuccessMessage"
    >
    </rav-form>
  </div>
  <div class="medium-8 cell">
    <h4>Two Factor Authentication</h4>
    <rav-switch [controlFormGroup]="twoFactorFormGroup" [controlName]="'twoFactorAuth'"></rav-switch>
    <div data-cy="twoFAOptions" class="margin-top-1" [formGroup]="twoFactorFormGroup" *ngIf="display2FactorMethod">
      <span>Select a verification method:</span>
      <label>
        <input type="radio" value="sms" formControlName="twoFactorMethod" />
        <span>SMS/Text Message</span>
      </label>
      <div
        class="grid-x grid-padding-x margin-left-0 grid-padding-y small-up-1 medium-up-2"
        *ngIf="twoFactorFormGroup.controls['twoFactorMethod'].value === 'sms'"
      >
        <rav-phone-number
          data-cy="sms-tel"
          controlName="phoneNumber"
          [controlFormGroup]="smsPhoneNumberForm"
          class="margin-right-1"
          [countryCodeList]="supportedCountryCodes"
        ></rav-phone-number>
        <button type="button" class="button" (click)="smsRequest()" [disabled]="smsPhoneNumberForm.invalid">
          {{ 'Send Request' }}
        </button>
      </div>
      <!-- For now, hide phone 2FA option to stop toll fraud -->
      <!-- <label>
        <input type="radio" value="voice" formControlName="twoFactorMethod" />
        <span>Phone Call</span>
      </label>
      <div
        class="grid-x grid-padding-x margin-left-0 grid-padding-y small-up-1 medium-up-2"
        *ngIf="twoFactorFormGroup.controls['twoFactorMethod'].value === 'voice'"
      >
        <input
          type="tel"
          data-cy="voice-tel"
          class="cell margin-right-1"
          placeholder="Enter Phone Number"
          [textMask]="{ mask: 'phone_number' | inputMask }"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="voicePhoneNumber"
        />
        <button type="button" class="button" (click)="voiceRequest()">
          {{ 'Send Request' }}
        </button>
      </div> -->
      <label>
        <input type="radio" value="app" formControlName="twoFactorMethod" />
        <span>Google Authenticator app</span>
      </label>
      <div
        class="grid-x grid-padding-x margin-left-0 grid-padding-y small-up-1 medium-up-2"
        *ngIf="twoFactorFormGroup.controls['twoFactorMethod'].value === 'app'"
      >
        <button type="button" class="button" (click)="authenticatorRequest()">
          {{ 'Setup Authenticator' }}
        </button>
      </div>
    </div>
    <a *ngIf="current2FAEnabled" (click)="displayBackupCodesModal()">Get Backup Codes</a>
    <h4 class="padding-top-1">Password</h4>
    <rav-message id="change-password-message"></rav-message>
    <div *ngIf="changePasswordSuccessMessage" class="small callout success">{{ changePasswordSuccessMessage }}</div>
    <button type="button" class="button" (click)="modal.open.next({ modalId: 'change-password' })">
      Change Password
    </button>
  </div>
</div>

<rav-change-password></rav-change-password>
<rav-verify2fa></rav-verify2fa>
<rav-authenticator2fa></rav-authenticator2fa>
<rav-backup-codes></rav-backup-codes>
<rav-extra-authentication></rav-extra-authentication>
